export const recordsUpdated = state => {
  return state['renewal']['records']['updated'];
};

export default recordsUpdated;
